import React from "react";

const CustomButtonOval = ({
    textLoad = "Processing",
    loading = false,
    onClick,
    className = "",
    children,
    isDisabled = false,
    ...props
}) => {
    const baseClasses = `
    inline-flex items-center justify-center
    px-4 py-1
    rounded-full
    text-xs font-medium
    transition-all
    focus:outline-none
    focus:ring-2
    focus:ring-cs-primary/40
    focus:ring-offset-1
  `;

    const disabledClasses = `
    opacity-50 cursor-not-allowed
  `;

    const finalClasses = `
    ${baseClasses}
    ${isDisabled || loading ? disabledClasses : ""}
    ${className}
  `;

    return (
        <button
            type="button"
            onClick={onClick}
            disabled={isDisabled || loading}
            className={finalClasses}
            {...props}
        >
            {loading && (
                <>
                    <svg
                        className="animate-spin h-4 w-4 mr-2"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                    >
                        <circle
                            className="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            strokeWidth="4"
                        />
                        <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                        />
                    </svg>
                    <span>{textLoad}...</span>
                </>
            )}

            {!loading && children}
        </button>
    );
};

export default CustomButtonOval;
